module.exports = __webpack_public_path__ + "static/media/broken-bells.95dee627.jpg";